<template>
    <transition>
        <router-view/>
    </transition>
</template>

<script>
export default {
    name: 'Register',
    mounted() {
        this.$store.dispatch('cookies/mountStripe');
    },
};
</script>
